import { forwardRef } from "react";
import {
  HelperText,
  TextField,
  TextFieldInput,
  TextFieldLabel,
} from "@hireart/component-library";
import { useField } from "formik";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { PatternFormat } from "react-number-format";

export const FormMaskedTextField = forwardRef(
  (
    {
      "aria-describedby": ariaDescribedBy = undefined,
      autoComplete = undefined,
      className = "",
      format,
      id = undefined,
      isDisabled = false,
      isOptional = false,
      label,
      name,
      onChange = () => {},
    },
    ref
  ) => {
    const [field, meta] = useField({ name });
    const inputId = id || name;
    const hasError = meta.touched && !isEmpty(meta.error);
    const helperTextIds = [
      hasError ? `${inputId}-error` : undefined,
      ariaDescribedBy,
    ]
      .filter(Boolean)
      .join(" ");

    const handleChange = (e) => {
      field.onChange(e);
      onChange(e, e.target.value);
    };

    return (
      <div>
        <TextField
          hasError={hasError}
          className={className}
          isDisabled={isDisabled}
          isOptional={isOptional}
        >
          <TextFieldLabel htmlFor={inputId}>{label}</TextFieldLabel>
          <PatternFormat
            {...field}
            aria-describedby={
              isEmpty(helperTextIds) ? undefined : helperTextIds
            }
            autoComplete={autoComplete}
            customInput={TextFieldInput}
            format={format}
            getInputRef={ref}
            id={inputId}
            onChange={handleChange}
          />
        </TextField>
        {hasError && (
          <HelperText id={`${inputId}-error`} hasError>
            {meta.error}
          </HelperText>
        )}
      </div>
    );
  }
);

FormMaskedTextField.displayName = "FormMaskedTextField";

FormMaskedTextField.propTypes = {
  "aria-describedby": PropTypes.string,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  format: PropTypes.string.isRequired,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isOptional: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};
